import type { ThemeTokens } from './types';

const palette = {
  white: '#FFFFFF',
  orange: '#FE7028',
  olive: '#9EC272',
  purple: '#826EC5',
  'mint-green': '#35D487',

  red: {
    base: '#FF5656',
    100: '#E56862',
    200: '#FD2D40',
  },

  yellow: {
    base: '#F3D743',
    300: '#EAB308',
  },

  green: {
    100: '#DBFEED',
    500: '#4BAC66',
  },

  black: {
    base: '#000000',
    25: '#F1F1F1',
    50: '#DDDDDD',
    100: '#D0D0D0',
    200: '#7D7D7D',
    500: '#6E6E73',
    600: '#424245',
    700: '#121212',
    800: '#000000',
  },

  blue: {
    500: '#0A84FF',
  },
} as const;

const semanticTokens: ThemeTokens = {
  primary: palette.black.base,
  secondary: palette.black.base,
  error: palette.red[200],
  danger: palette.red.base,
  black: palette.black.base,
  white: palette.white,
  accent: palette.black[700],
  'accent-secondary': palette.black[500],
  'accent-light': palette.black[200],
  warning: palette.orange,
  'warning-subtle': palette.yellow.base,
  'success-subtle': palette.olive,

  'bg-primary': palette.black[25],
  'bg-secondary': palette.black[50],
  'bg-tertiary': palette.black[200],
  'bg-tertiary-subtle': palette.black[500],
  'bg-accent': palette.black[700],
  'bg-accent-secondary': palette.black[500],
  'bg-accent-tertiary': palette.black[100],
  'bg-accent-subtle': palette.black[25],
  'bg-success': palette.green[100],
  'bg-white': palette.white,

  'text-accent': palette.black[700],
  'text-accent-secondary': palette.black[700],
  'text-primary': palette.black[700],
  'text-secondary': palette.black[600],
  'text-tertiary': palette.black[500],
  'text-link': palette.blue[500],
  'text-danger': palette.red.base,
  'text-error': palette.red[200],
  'text-warning': palette.orange,
  'text-warning-subtle': palette.yellow[300],
  'text-success': palette.green[500],
  'text-on-dark': palette.white,
  'text-black': palette.black.base,

  'icon-primary': palette.black[600],
  'icon-secondary': palette.black[600],
  'icon-tertiary': palette.black[500],
  'icon-link': palette.blue[500],
  'icon-accent': palette.black[700],
  'icon-white': palette.white,
  'icon-error': palette.red[200],
  'icon-success': palette['mint-green'],
  'icon-success-secondary': palette.green[500],

  'border-primary': palette.black[100],
  'border-secondary': palette.black[200],
  'border-tertiary': palette.black[500],
  'border-link': palette.black[500],
  'border-hover': palette.black[700],
  'border-focus': palette.black[700],
  'border-error': palette.red[200],

  'box-shadow-primary': palette.black[25],
  'box-shadow-secondary': palette.black[100],
  'box-shadow-tertiary': palette.black[500],

  'text-field-base': palette.black[200],

  'button-primary': palette.black.base,
  'button-secondary': palette.blue[500],
  'button-tertiary': palette.black[200],
  'button-accent-subtle': palette.black[100],
  'button-surface-light': palette.black[500],
  'button-surface': palette.black[600],
  'button-surface-subtle': palette.black[700],
  'button-error': palette.red[200],
  'button-danger': palette.red.base,
  'button-success': palette.green[500],

  // Components
  'logo-color': palette.black.base,
  'header-bg-color': palette.black.base,
  'header-text-color': palette.white,

  'footer-border-color': palette.black[25],
  'footer-bg-color': palette.black[25],
  'footer-text-color': palette.black.base,
  'footer-divider-color': palette.black[500],
  'footer-logo-color': palette.black.base,

  'sidebar-badge-bg-color': palette.black[500],
  'sidebar-badge-text-color': palette.white,

  'snackbar-ingo-color': palette.blue[500],
};

export const colors = {
  ...semanticTokens,
};
